export default __webpack_public_path__ + "static/media/operation.55f740d7.jpg";